import {useCallback} from "react";

import {PricesCityAnalyticsLocation} from "../tracking/prices_city_analytics";
import {PricesCitySectionName, trackPricesCityViewSection} from "../tracking/track_prices_city_view_section";
import {ViewSectionTracker} from "./ViewSectionTracker";

interface IProps {
    sectionName: PricesCitySectionName;
    location: PricesCityAnalyticsLocation;
}

/** Renders nothing visible - drop it inside a section to report that section as seen, once per page view. */
export const PricesCityViewSectionTracker = (props: IProps) => {
    const {sectionName, location} = props;
    const handleVisible = useCallback(() => trackPricesCityViewSection(sectionName, location), [sectionName, location]);

    return <ViewSectionTracker id={sectionName} onVisible={handleVisible} />;
};
import {useCallback} from "react";

import {PricesCityAnalyticsLocation} from "../tracking/prices_city_analytics";
import {PricesCitySectionName, trackPricesCityViewSection} from "../tracking/track_prices_city_view_section";
import {ViewSectionTracker} from "./ViewSectionTracker";

interface IProps {
    sectionName: PricesCitySectionName;
    location: PricesCityAnalyticsLocation;
}

/** Renders nothing visible - drop it inside a section to report that section as seen, once per page view. */
export const PricesCityViewSectionTracker = (props: IProps) => {
    const {sectionName, location} = props;
    const handleVisible = useCallback(() => trackPricesCityViewSection(sectionName, location), [sectionName, location]);

    return <ViewSectionTracker id={sectionName} onVisible={handleVisible} />;
};
